import Swiper, { Navigation, Pagination, Autoplay } from 'swiper'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import 'swiper/css/autoplay'

document.addEventListener('DOMContentLoaded', () => {
  // #region NumberCounter
  const counter = document.querySelector(
    '.pk-number-counter .percent .percent-value'
  )
  const mObserver = new MutationObserver(records => {
    counter.dataset.currentValue = counter.innerText

    if (
      isNaN(counter.dataset.currentValue) &&
      counter.dataset.currentValue !==
        counter.closest('.pk-number-counter').dataset.numberValue
    ) {
      counter.innerText =
        counter.closest('.pk-number-counter').dataset.numberValue
    }
  })
  if (counter) {
    mObserver.observe(counter, {
      childList: true
    })
  }
  // #endregion

  // #region Swiper
  const swiperContainers = document.querySelectorAll('.swiper-container')

  swiperContainers.forEach(container => {
    const prevButton = document.createElement('div')
    prevButton.classList.add('swiper-button-prev')

    const nextButton = document.createElement('div')
    nextButton.classList.add('swiper-button-next')

    const pagination = document.createElement('div')
    pagination.classList.add('swiper-pagination')

    container.appendChild(prevButton)
    container.appendChild(nextButton)
    container.appendChild(pagination)
  })

  const swiperGastbeiträge = new Swiper('.gastbeiträge-swiper', {
    modules: [Navigation, Autoplay],
    effect: 'fade',
    slidesPerView: 2,
    breakpoints: {
      480: {
        slidesPerView: 3
      },
      981: {
        slidesPerView: 4
      },
      1400: {
        slidesPerView: 5
      }
    },
    loop: true,
    spaceBetween: 50,
    autoplay: {
      delay: 3000
    },
    speed: 500,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    }
  })

  const swiperPublications = new Swiper('.publications-swiper', {
    modules: [Navigation, Autoplay],
    effect: 'fade',
    slidesPerView: 1,
    breakpoints: {
      480: {
        slidesPerView: 2
      },
      981: {
        slidesPerView: 3
      },
      1400: {
        slidesPerView: 4
      }
    },
    loop: true,
    spaceBetween: 50,
    autoplay: {
      delay: 3000
    },
    speed: 500,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    }
  })
  // #endregion
})
